// BUG-050 — Admin -> Branding -> Palette: the colour picker made the obvious control.
//
// The old row was a small swatch that read as a PREVIEW next to a free-text hex box, and
// the box was the only thing that looked interactive. These keys name the picker as the
// control, keep the current hex readable as text (a practitioner comparing against a
// brand guide needs to SEE the value, not just the colour), and put hex ENTRY behind a
// disclosure — still there for a designer's exact code, no longer the default path.
export default {
  fr: {
    "brand.colorPickHint": "Cliquez pour choisir une couleur",
    "brand.hexToggle": "Saisir un code hexadécimal",
    "brand.hexLabel": "Code hexadécimal",
    "brand.hexInvalid": "Entrez une couleur hexadécimale, par exemple #1A2B3C.",
  },
  en: {
    "brand.colorPickHint": "Click to choose a colour",
    "brand.hexToggle": "Enter a hex code",
    "brand.hexLabel": "Hex code",
    "brand.hexInvalid": "Enter a hex colour, for example #1A2B3C.",
  },
  es: {
    "brand.colorPickHint": "Haga clic para elegir un color",
    "brand.hexToggle": "Introducir un código hexadecimal",
    "brand.hexLabel": "Código hexadecimal",
    "brand.hexInvalid": "Introduzca un color hexadecimal, por ejemplo #1A2B3C.",
  },
};
